<app-main-header></app-main-header>
<main class="home">
  <div class="">
    <div class="row">
      <div class="col- col-lg-4 col-xs-12 couple circle">
        <img src="assets/main-bg2.jpg" class="main-bg img-fluid" />
      </div>
      <div class="col col-lg-5 col-xs-12 right-border-white">
        <section class="description">
          <h1 class=" ">WYBIERZ<br/>IDEALNY&nbsp;KOLOR</h1>
          <h2>NA ELEWACJĘ</h2>

          <p class="text">
            Aplikacja Strefa Koloru to intuicyjne w obsłudze narzędzie, które pozwoli Ci zaprojektować kolorystykę
            elewacji
            Twojego domu, wykorzystując bogatą paletę barw tynków Knauf. <span class="extended">Wybierając kolory możesz
            korzystać z gotowych
            projektów lub dodać zdjęcie swojego domu.
            Możesz eksperymentować, tworząc różne zestawienia kolorystyczne, porównywać odcienie, aż do uzyskania
            wymarzonego efektu. Program podpowie Ci także, jaki rodzaj tynku wybrać, obliczy potrzebną ilość i&nbsp;wskaże
            najbliższy punkt sprzedaży.</span><br/></p>
          <h3>Wejdź do świata kolorów Knauf!</h3>
          <h3 class="strong">Gotowy do pracy? Zaczynamy!</h3>
        </section>
      </div>
      <div class="col- col-lg-3 col-xs-12">
        <section class="points">
          <ol>
            <li class="wow fadeInUp" data-wow-delay="0.2s">Wybór domu</li>
            <li class="wow fadeInUp" data-wow-delay="0.4s">Wybór kolorów</li>
            <li class="wow fadeInUp" data-wow-delay="0.6s">Wybór tynku</li>
            <li class="wow fadeInUp" data-wow-delay="0.8s">Kalkulator zużycia</li>
            <li class="wow fadeInUp" data-wow-delay="1s">Wybór sklepu</li>
          </ol>
        </section>
      </div>
    </div>

  </div>
</main>

<app-footer [next]="next"></app-footer>
